import type { Locale } from '@/intl/types'
import { countryData } from '@sunwebgroup/ui-components'

export function getDefaultCountry(locale: Locale) {
  const countryCode = locale.split('-')[1]
  return countryData.find(({ isoCode }) => isoCode === countryCode) ?? countryData[0]
}
